var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOptionBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 7,
    fill: "#F3F3F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 11.8033C14.7447 11.8033 14.1323 11.1909 14.1323 10.4355C14.1323 9.68013 14.7447 9.06775 15.5001 9.06775C16.2555 9.06775 16.8679 9.68013 16.8679 10.4355C16.8679 11.1909 16.2555 11.8033 15.5001 11.8033Z",
    fill: "#8987A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 16.8644C14.7447 16.8644 14.1323 16.252 14.1323 15.4966C14.1323 14.7412 14.7447 14.1288 15.5001 14.1288C16.2555 14.1288 16.8679 14.7412 16.8679 15.4966C16.8679 16.252 16.2555 16.8644 15.5001 16.8644Z",
    fill: "#8987A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 21.9249C14.7447 21.9249 14.1323 21.3125 14.1323 20.5571C14.1323 19.8017 14.7447 19.1894 15.5001 19.1894C16.2555 19.1894 16.8679 19.8017 16.8679 20.5571C16.8679 21.3125 16.2555 21.9249 15.5001 21.9249Z",
    fill: "#8987A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptionBg);
export default __webpack_public_path__ + "static/media/icon-option-bg.094ceafafab1432824616764bf4a534c.svg";
export { ForwardRef as ReactComponent };